import { TenantType } from '@payflip/utils';
import { logos } from './logos';
import { PayflipLogo } from './logos/logo-payflip';

export interface TenantLogoProps {
  userTenant: TenantType;
  noText?: boolean;
}

export function TenantLogo({
  userTenant,
  noText = false
}: TenantLogoProps): JSX.Element {
  const TenantLogo = userTenant !== null ? logos[userTenant] : null;

  if (TenantLogo !== null && TenantLogo !== undefined) {
    return <TenantLogo noText={noText} />;
  }

  return <PayflipLogo noText={noText} />;
}

export * from './logos/logo-payflip';
